import { Col, Row } from "reactstrap";
import React, { useEffect, useState } from "react";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";
import AppModal from "../../Common/AppModal";

import {
  createSecurityAuthRole,
  createSecurityAuthRoleSuccess,
  getMasterSecurityAuthCapabilityList,
  getSecurityAuthRoleList,
  updateSecurityAuthRole,
  updateSecurityAuthRoleSuccess,
} from "../../../store/actions";

export default function AddEditSecurityRole({
  modal,
  setModal,
  toggle,
  isEdit,
  updateDetails,
  reportName,
}) {
  const dispatch = useDispatch();

  const defaultData = {
    Name: "New Role",
    Description: "",
    Notes: "",
    CssColourBackground: "#449f37",
    CssColourBorder: "#000000",
    CssColourText: "#fafafa",
    securityauthroletoauthcapability_list: [],
  };

  const [createUpdateData, setCreateUpdateData] = useState(defaultData);
  useEffect(() => {
    if (isEdit) return;
    setCreateUpdateData(defaultData);
  }, [isEdit]);
  const { masterSecurityAuthCapabilityListAPI } = useSelector((state) => ({
    masterSecurityAuthCapabilityListAPI:
      state.Security.masterSecurityAuthCapabilityList
        ?.mastersecurityauthcapability_list,
  }));
  const [
    securityCapabilitiesListReformated,
    setSecurityCapabilitiesListReformated,
  ] = useState([]);

  const [searchResult, setSearchResult] = useState([]);
  const [search, setSearch] = useState("");
  const [allowedSearchFilters, setAllowedSearchFilters] = useState([
    "Id",
    "Name",
    "Description",
    "GroupName",
  ]);
  useEffect(() => {
    dispatch(getMasterSecurityAuthCapabilityList());
  }, []);

  useEffect(() => {
    if (isEmpty(masterSecurityAuthCapabilityListAPI)) return;
    // go trough the masterSecurityAuthCapabilityListAPI list and group all properties of MasterSecurityAuthGroup_Id same value together and add property GroupName to each item
    // add property GroupName to each item

    let reformatedList = masterSecurityAuthCapabilityListAPI.reduce(
      (acc, item) => {
        const found = acc.find(
          (element) =>
            element.MasterSecurityAuthGroup_Id ===
            item.MasterSecurityAuthGroup_Id
        );
        if (!found) {
          acc.push({
            ...item,
            GroupName: item?.Name?.split(" ")[0],
            Expanded: false,
          });
        } else {
          found.GroupName = found?.Name?.split(" ")[0];
        }
        return acc;
      },
      []
    );

    // add property GroupName to each item

    setSecurityCapabilitiesListReformated(reformatedList);
  }, [masterSecurityAuthCapabilityListAPI]);

  useEffect(() => {
    let filteredData = masterSecurityAuthCapabilityListAPI;
    filteredData = filteredData?.filter((item) => {
      let isAllowed = false;
      allowedSearchFilters?.forEach((filter) => {
        if (item[filter]?.toString()?.toLowerCase()?.includes(search)) {
          isAllowed = true;
        }
      });
      return isAllowed;
    });

    setSearchResult(filteredData);
  }, [masterSecurityAuthCapabilityListAPI, search]);
  useEffect(() => {
    if (!isEdit) return;
    if (isEmpty(updateDetails)) return;
    setCreateUpdateData({
      Id: updateDetails?.Id,
      Name: updateDetails?.Name,
      Description: updateDetails?.Description,
      Notes: updateDetails?.Notes,
      CssColourBackground: updateDetails?.CssColourBackground,
      CssColourBorder: updateDetails?.CssColourBorder,
      CssColourText: updateDetails?.CssColourText,
      securityauthroletoauthcapability_list:
        updateDetails?.securityauthroletoauthcapability_list ?? [],
    });
  }, [updateDetails, isEdit]);

  const handleCreateUpdate = (type) => {
    // check if all fields are filled
    // Staff

    // StartDateTime

    switch (reportName) {
      case "securityRoleList":
        if (type === "create") {
          dispatch(createSecurityAuthRole([createUpdateData]));
        }
        if (type === "update") {
          dispatch(updateSecurityAuthRole([createUpdateData]));
        }
        break;

      default:
        break;
    }
  };

  const { securityAuthRoleCreateSuccessAPI, securityAuthRoleUpdateSuccessAPI } =
    useSelector((state) => ({
      securityAuthRoleCreateSuccessAPI:
        state.Security.securityAuthRoleCreateSuccess,
      securityAuthRoleUpdateSuccessAPI:
        state.Security.securityAuthRoleUpdateSuccess,
    }));

  useEffect(() => {
    if (isEmpty(securityAuthRoleCreateSuccessAPI)) return;
    if (securityAuthRoleCreateSuccessAPI?.status === 200) {
      toast.success(securityAuthRoleCreateSuccessAPI?.message);
      dispatch(getSecurityAuthRoleList());

      setModal(false);
    } else {
      toast.error(securityAuthRoleCreateSuccessAPI?.message);
    }
    dispatch(createSecurityAuthRoleSuccess([]));
  }, [securityAuthRoleCreateSuccessAPI]);

  useEffect(() => {
    if (isEmpty(securityAuthRoleUpdateSuccessAPI)) return;
    if (securityAuthRoleUpdateSuccessAPI?.status === 200) {
      toast.success(securityAuthRoleUpdateSuccessAPI?.message);
      dispatch(getSecurityAuthRoleList());

      setModal(false);
    } else {
      toast.error(securityAuthRoleUpdateSuccessAPI?.message);
    }
    dispatch(updateSecurityAuthRoleSuccess([]));
  }, [securityAuthRoleUpdateSuccessAPI]);

  const handleCheckUncheckAllItems = (e) => {
    setCreateUpdateData((prev) => {
      const temp = { ...prev };
      if (e.target.checked) {
        //go trough the searchResults and add to createUpdateData?.securityauthroletoauthcapability_list
        // as many items as there are in searchResults
        searchResult?.forEach((item) => {
          temp.securityauthroletoauthcapability_list.push({
            MasterSecurityAuthCapability_Id: item?.Id,
          });
        });
      } else {
        //go trough  createUpdateData?.securityauthroletoauthcapability_list
        // and remove all items
        temp.securityauthroletoauthcapability_list = [];
      }
      return temp;
    });
  };
  return (
    <AppModal
      open={modal}
      onClose={toggle}
      title={isEdit ? "Edit Security Role" : "Create New Security Role"}
      icon={<SecurityOutlinedIcon />}
      headerAccent="indigo"
      size="md"
      submitLabel={isEdit ? "Update" : "Create"}
      submitColor="success"
      onSubmit={() => handleCreateUpdate(isEdit ? "update" : "create")}
    >
          <Row>
            <Col lg={8}>
              <Row className="g-3">
                <div>
                  <h6>Role Preview</h6>
                </div>
                <Col lg={6}>
                  <div className={"p-0"}>
                    <div
                      className={"badge mb-2"}
                      style={{
                        color: createUpdateData?.CssColourText ?? "#000000",
                        background:
                          createUpdateData?.CssColourBackground ?? "#ffffff",
                        border: `1px solid ${
                          createUpdateData?.CssColourBorder ?? "#ffffff"
                        }`,
                      }}
                    >
                      <span className={""}>
                        {createUpdateData?.Name ?? "Name"}
                      </span>
                    </div>
                  </div>
                  <div
                    className={
                      "d-flex align-items-center cursor-pointer status-edit-and-name-block"
                    }
                  >
                    <input
                      autoFocus={true}
                      className={"w-100"}
                      type="text"
                      value={createUpdateData?.Name ?? ""}
                      onChange={(e) => {
                        setCreateUpdateData((prev) => {
                          const temp = { ...prev };
                          temp.Name = e.target.value;
                          return temp;
                        });
                      }}
                    />
                  </div>
                </Col>
                <Col lg={6}>
                  <div className={"ms-2 me-2 d-flex align-items-center"}>
                    <input
                      style={{ background: createUpdateData?.CssColourText }}
                      className={"color-picker-like-input-circle"}
                      value={createUpdateData?.CssColourText ?? "#000000"}
                      type="color"
                      onChange={(e) => {
                        setCreateUpdateData((prev) => {
                          const temp = { ...prev };
                          temp.CssColourText = e.target.value;
                          return temp;
                        });
                      }}
                    />
                    <span className={"ms-2"}>Text Colour</span>
                  </div>
                  <div className={"m-0 ms-2 me-2 d-flex align-items-center"}>
                    <input
                      style={{
                        background: createUpdateData?.CssColourBackground,
                      }}
                      className={"color-picker-like-input-circle"}
                      value={createUpdateData?.CssColourBackground ?? "#ffffff"}
                      type="color"
                      onChange={(e) => {
                        setCreateUpdateData((prev) => {
                          const temp = { ...prev };
                          temp.CssColourBackground = e.target.value;
                          return temp;
                        });
                      }}
                    />
                    <span className={"ms-2"}>Background Colour</span>
                  </div>
                  <div className={"m-0 ms-2 me-2 d-flex align-items-center"}>
                    <input
                      style={{ borderColor: createUpdateData?.CssColourBorder }}
                      className={"color-picker-like-input-circle"}
                      value={createUpdateData?.CssColourBorder ?? "#ffffff"}
                      type="color"
                      onChange={(e) => {
                        setCreateUpdateData((prev) => {
                          const temp = { ...prev };
                          temp.CssColourBorder = e.target.value;
                          return temp;
                        });
                      }}
                    />
                    <span className={"ms-2"}>Border Colour</span>
                  </div>
                </Col>
                <hr />
                <Col lg={12}>
                  <div>
                    <div className={"pt-0"}>
                      <div>
                        <label>Description</label>{" "}
                        <textarea
                          className="form-control"
                          id="exampleFormControlTextarea1"
                          rows="3"
                          value={createUpdateData?.Description}
                          onChange={(e) => {
                            setCreateUpdateData({
                              ...createUpdateData,
                              Description: e.target.value,
                            });
                          }}
                        ></textarea>
                      </div>
                      <div className={"mt-4"}>
                        <label>Notes</label>{" "}
                        <textarea
                          className="form-control"
                          id="exampleFormControlTextarea1"
                          rows="3"
                          value={createUpdateData.Notes}
                          onChange={(e) => {
                            setCreateUpdateData({
                              ...createUpdateData,
                              Notes: e.target.value,
                            });
                          }}
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
            <Col
              lg={4}
              style={{ borderLeft: "1px solid #d3d3d3" }}
              className={"p-1"}
            >
              <div className={"w-100"}>
                <div className={"d-flex justify-content-between"}>
                  <h6>Allow Access</h6>
                  <span className={"d-flex align-items-center"}>
                    <input
                      type="checkbox"
                      onChange={(e) => {
                        handleCheckUncheckAllItems(e);
                      }}
                    />
                    <i className="fa-solid fa-layer-group ms-2"></i>
                  </span>
                </div>
                <div className={"w-100"}>
                  {/*  search*/}
                  <div className="input-group mb-3 w-100">
                    <input
                      type="search"
                      className="form-control p-1 m-0 w-100"
                      placeholder="Search"
                      aria-label="Search"
                      value={search}
                      onChange={(e) => {
                        setSearch(e.target.value);
                      }}
                    />{" "}
                  </div>
                </div>
                <div>
                  <div className={"mt-2"}>
                    {/*  Group Together list by name*/}
                    {securityCapabilitiesListReformated?.map(
                      (groupItem, index) => (
                        <div key={index}>
                          <div className={"access-group-block"}>
                            <div>
                              <div
                                className={
                                  "d-flex flex-row align-items-center justify-content-between badge badge-soft-primary mb-2 cursor-pointer w-100"
                                }
                              >
                                <span
                                  className={"text-start w-100"}
                                  onClick={() => {
                                    setSecurityCapabilitiesListReformated(
                                      securityCapabilitiesListReformated.map(
                                        (item) => {
                                          if (item?.Id === groupItem?.Id) {
                                            item.Expanded = !item.Expanded;
                                          }
                                          return item;
                                        }
                                      )
                                    );
                                  }}
                                >
                                  {groupItem?.GroupName}
                                </span>
                                <span className={"d-flex align-items-center"}>
                                  <span className={"me-1"}>
                                    <input
                                      type="checkbox"
                                      onChange={(e) => {
                                        setCreateUpdateData((prev) => {
                                          const temp = { ...prev };
                                          if (e.target.checked) {
                                            //go trough the searchResults and add to createUpdateData?.securityauthroletoauthcapability_list
                                            // as many items as there are in searchResults with searchResults?.MasterSecurityAuthGroup_Id === groupItem?.MasterSecurityAuthGroup_Id
                                            masterSecurityAuthCapabilityListAPI?.forEach(
                                              (item) => {
                                                if (
                                                  item?.MasterSecurityAuthGroup_Id ===
                                                  groupItem?.MasterSecurityAuthGroup_Id
                                                ) {
                                                  // if property securityauthroletoauthcapability_list does not exist create it

                                                  temp.securityauthroletoauthcapability_list.push(
                                                    {
                                                      MasterSecurityAuthCapability_Id:
                                                        item?.Id,
                                                    }
                                                  );
                                                }
                                              }
                                            );
                                          } else {
                                            //go trough  createUpdateData?.securityauthroletoauthcapability_list
                                            // first find the group id and then remove all items with that group id

                                            temp.securityauthroletoauthcapability_list =
                                              temp.securityauthroletoauthcapability_list.filter(
                                                (item2) =>
                                                  masterSecurityAuthCapabilityListAPI.find(
                                                    (search) =>
                                                      search?.Id ===
                                                      item2?.MasterSecurityAuthCapability_Id
                                                  )
                                                    ?.MasterSecurityAuthGroup_Id !==
                                                  groupItem?.MasterSecurityAuthGroup_Id
                                              );
                                            //
                                          }
                                          return temp;
                                        });
                                      }}
                                      checked={
                                        //go trough the list createUpdateData?.securityauthroletoauthcapability_list?
                                        // and check if any of the items has MasterSecurityAuthGroup_Id === groupItem?.MasterSecurityAuthGroup_Id
                                        // if yes then check the checkbox
                                        createUpdateData?.securityauthroletoauthcapability_list?.some(
                                          (item) =>
                                            masterSecurityAuthCapabilityListAPI.find(
                                              (search) =>
                                                search?.Id ===
                                                item?.MasterSecurityAuthCapability_Id
                                            )?.MasterSecurityAuthGroup_Id ===
                                            groupItem?.MasterSecurityAuthGroup_Id
                                        )
                                      }
                                    />
                                  </span>
                                  <span
                                    onClick={() => {
                                      setSecurityCapabilitiesListReformated(
                                        securityCapabilitiesListReformated.map(
                                          (item) => {
                                            if (item?.Id === groupItem?.Id) {
                                              item.Expanded = !item.Expanded;
                                            }
                                            return item;
                                          }
                                        )
                                      );
                                    }}
                                  >
                                    {groupItem?.Expanded ? (
                                      <i
                                        className={"fa-solid fa-chevron-up"}
                                      ></i>
                                    ) : (
                                      <i
                                        className={"fa-solid fa-chevron-down"}
                                      ></i>
                                    )}{" "}
                                  </span>
                                </span>
                              </div>
                              {groupItem?.Expanded && (
                                <div>
                                  {masterSecurityAuthCapabilityListAPI?.map(
                                    (item, index) => (
                                      <div key={index}>
                                        {groupItem?.MasterSecurityAuthGroup_Id ===
                                          item?.MasterSecurityAuthGroup_Id && (
                                          <div
                                            className={
                                              "ms-3 d-flex flex-row align-items-center justify-content-between badge badge-soft-info mb-2 cursor-pointer  "
                                            }
                                          >
                                            <span
                                              className={"text-start w-100 "}
                                            >
                                              {item?.Name}
                                            </span>
                                            <span
                                              className={
                                                "d-flex align-items-center"
                                              }
                                            >
                                              <span
                                                style={{ marginRight: "13px" }}
                                              >
                                                <input
                                                  type="checkbox"
                                                  onChange={(e) => {
                                                    setCreateUpdateData(
                                                      (prev) => {
                                                        const temp = {
                                                          ...prev,
                                                        };
                                                        if (e.target.checked) {
                                                          // check if property securityauthroletoauthcapability_list exist if not create it

                                                          temp.securityauthroletoauthcapability_list?.push(
                                                            {
                                                              MasterSecurityAuthCapability_Id:
                                                                item?.Id,
                                                            }
                                                          );
                                                        } else {
                                                          temp.securityauthroletoauthcapability_list =
                                                            temp.securityauthroletoauthcapability_list.filter(
                                                              (item2) =>
                                                                item2?.MasterSecurityAuthCapability_Id !==
                                                                item?.Id
                                                            );
                                                        }
                                                        return temp;
                                                      }
                                                    );
                                                  }}
                                                  checked={createUpdateData?.securityauthroletoauthcapability_list?.some(
                                                    (item2) =>
                                                      item2?.MasterSecurityAuthCapability_Id ===
                                                      item?.Id
                                                  )}
                                                />
                                              </span>
                                            </span>
                                          </div>
                                        )}
                                      </div>
                                    )
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      )
                    )}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
    </AppModal>
  );
}
